import styled from "@emotion/styled"
import { FlexContainer } from "../../../../styled/flexbox.styled"

export const StyledTimeInput = styled.input`
  width: 100px;
  height: 100%;
  background: transparent;
  border: none;
  padding: 10px;
`

export const TimeInputContainer = styled(FlexContainer)`
  width: 100%;
`
